import React, { useEffect } from 'react';
import './BlogModal.css';

const BlogModal = ({ blog, onClose }) => {
  useEffect(() => {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  if (!blog) return null;

  // Convert YouTube/Vimeo URLs to embed format
  const getEmbedUrl = (url) => {
    if (!url) return null;

    // YouTube URL patterns
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      let videoId = '';

      if (url.includes('youtube.com/watch?v=')) {
        videoId = url.split('watch?v=')[1].split('&')[0];
      } else if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1].split('?')[0];
      } else if (url.includes('youtube.com/embed/')) {
        return url; // Already in embed format
      }

      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }

    // Vimeo URL patterns
    if (url.includes('vimeo.com')) {
      if (url.includes('vimeo.com/video/')) {
        const videoId = url.split('vimeo.com/video/')[1].split('?')[0];
        return `https://player.vimeo.com/video/${videoId}`;
      } else if (url.includes('player.vimeo.com/video/')) {
        return url; // Already in embed format
      } else {
        const videoId = url.split('vimeo.com/')[1].split('?')[0];
        return `https://player.vimeo.com/video/${videoId}`;
      }
    }

    return url; // Return as-is if not recognized
  };

  const isVideo = blog.media_type === 'video';
  const embedUrl = isVideo ? getEmbedUrl(blog.video_url) : null;

  return (
    <div className="blog-modal-overlay" onClick={onClose}>
      <div className="blog-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <div className="modal-content">
          {blog.category && (
            <span className="modal-category">{blog.category}</span>
          )}
          <h2>{blog.title}</h2>

          {blog.featured_image && !isVideo && (
            <div className="modal-image">
              <img src={`http://localhost/ehaazri/${blog.featured_image}`} alt={blog.title} />
            </div>
          )}

          {isVideo && embedUrl && (
            <div className="modal-video">
              <iframe
                src={embedUrl}
                title={blog.title}
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}

          <div className="modal-body" dangerouslySetInnerHTML={{ __html: blog.content || blog.excerpt }} />

          <div className="modal-meta">
            {blog.author && (
              <p><strong>Author:</strong> {blog.author}</p>
            )}
            {blog.publish_date && (
              <p><strong>Published:</strong> {new Date(blog.publish_date).toLocaleDateString()}</p>
            )}
            {blog.tags && (
              <div className="modal-tags">
                <strong>Tags:</strong>
                {blog.tags.split(',').map((tag, index) => (
                  <span key={index} className="tag">{tag.trim()}</span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogModal;
